var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('van-empty',{attrs:{"description":"暂不支持此办事项办理"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }